var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/warningcircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#FF334B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99826 3.11133C8.48918 3.11133 8.88715 3.5093 8.88715 4.00022V8.66688C8.88715 9.1578 8.48918 9.55577 7.99826 9.55577C7.50734 9.55577 7.10938 9.1578 7.10938 8.66688V4.00022C7.10938 3.5093 7.50734 3.11133 7.99826 3.11133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 12.667C8.55228 12.667 9 12.2193 9 11.667C9 11.1147 8.55228 10.667 8 10.667C7.44772 10.667 7 11.1147 7 11.667C7 12.2193 7.44772 12.667 8 12.667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.db36684ec8d70518ce8a7c9abc5dcf0b.svg";
export { ForwardRef as ReactComponent };